/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretUpSmall: {
  name: 'caret_up_small';
  data: string;
} = {
  name: 'caret_up_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 14.498a.75.75 0 0 1 0-1.06L12.188 9.5a.75.75 0 0 1 1.06 0l3.938 3.937a.75.75 0 0 1-1.06 1.06l-3.408-3.406L9.311 14.5a.75.75 0 0 1-1.06 0Z" fill="currentColor"/></svg>`
};
